/** Ensures sources dialogs appear above the file viewer modal (default z-index 1300). */
export const SOURCES_DIALOG_STACK_PROPS = Object.freeze({
    slotProps: {
        root: {
            sx: {zIndex: 1400},
        },
    },
});
